import gql from "graphql-tag";

export const ADMIN_LOGIN = gql`
  mutation($email: String!, $password: String!) {
    adminLogin(email: $email, password: $password) {
      token
    }
  }
`;
